import { Spinner } from '@creditornot/cb-progress';
import React, { useMemo } from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { SpinnerContainer } from 'modules/shared-menu/components/CommonStyles';
import { ScopeContextProvider } from 'modules/shared-menu/contexts/ScopeContext';
import { useLoadSelectionData } from 'modules/shared-menu/hooks/useSelectionData';
import { OfferingPlatformScope } from 'modules/shared-menu/types';

import { TranslationsRoot } from '../../components/TranslationsRoot';
import { SelectionInfoContextProps, SelectionInfoContextProvider } from '../../contexts/SelectionInfoContext';

type VenueLevelTranslationsPageProps = {
  venue: Venue;
  isSingleVenue: boolean;
  isSharedVenue: boolean;
  selectionId: string;
};

export const VenueLevelTranslationsPage = ({
  venue,
  isSingleVenue,
  isSharedVenue,
  selectionId,
}: VenueLevelTranslationsPageProps) => {
  const scope: OfferingPlatformScope = { id: venue.id, type: 'venue' };

  const { loadingInitialSelectionData, selectionData } = useLoadSelectionData({ selectionId, scope });

  const vlmeConfig: SelectionInfoContextProps['vlmeConfig'] = useMemo(
    () => ({
      isSingleVenue,
      isSharedVenue,
      venue,
    }),
    [isSharedVenue, isSingleVenue, venue],
  );

  if (loadingInitialSelectionData) {
    return (
      <SpinnerContainer>
        <Spinner size="large" color="blue" />
      </SpinnerContainer>
    );
  }

  if (!selectionData?.selection) {
    throw new Error('Selection not found, this should not happen!');
  }

  return (
    <ScopeContextProvider value={{ id: venue.id, type: 'venue' }}>
      <SelectionInfoContextProvider
        value={{
          country: venue.country,
          selection: selectionData.selection,
          vlmeConfig,
        }}
      >
        <TranslationsRoot />
      </SelectionInfoContextProvider>
    </ScopeContextProvider>
  );
};
